import { FC, ChangeEvent } from 'react';
import { ArrowRight, Euro } from 'lucide-react';

import { useTranslate } from 'hooks/useTranslate';
import { formatCurrencyDecimals, formatNumber } from 'utils/formats';

import { SellPlan } from 'modules/incentivesMarket/pages/IncentiveOfferDetail/types/SellUnitsSelection';

type AmountInputProps = {
  value: string;
  max: number;
  onChange: (raw: string) => void;
  resultUnits: number;
  plans: SellPlan[];
  selected: Record<string, number>;
  disabled?: boolean;
};

const AmountInput: FC<AmountInputProps> = ({
  value,
  max,
  onChange,
  resultUnits,
  plans,
  selected,
  disabled,
}) => {
  const { t } = useTranslate();

  const distributionLabel =
    plans
      .filter((plan) => selected[plan.id] > 0)
      .map((plan) => `${plan.name}: ${formatNumber(selected[plan.id])}`)
      .join(' · ') || '—';

  return (
    <div>
      <label className="form-label fs-14px fw-medium text-secondary mb-1">
        {t('IncentivesMarketSellByAmountQuestion')}
      </label>
      <div className="incentive-offer-sell-units-panel__amount-input-wrap">
        <Euro size={16} className="text-soft" />
        <input
          inputMode="decimal"
          value={value}
          placeholder="0,00"
          disabled={disabled}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.value)
          }
          className="incentive-offer-sell-units-panel__amount-input tnum"
        />
      </div>
      <p className="form-note mt-1 mb-0">
        {t('IncentivesMarketSellByAmountMaxHint', {
          max: formatCurrencyDecimals(max),
        })}
      </p>

      <div className="incentive-offer-sell-units-panel__amount-summary mt-3">
        <span className="fs-14px text-soft">
          {t('IncentivesMarketSellByAmountEquivalent')}
        </span>
        <span className="fs-14px fw-semibold text-dark tnum">
          {formatNumber(resultUnits)} {t('IncentivesMarketUnits').toLowerCase()}
        </span>
        <ArrowRight size={14} className="ml-auto text-soft" />
        <span className="fs-12px text-soft tnum">{distributionLabel}</span>
      </div>
    </div>
  );
};

export default AmountInput;
